<template>
  <div>

    <v-container fluid class="white elevation-3 margen d-flex justify-space-around">
      <v-row class="pb-3 d-flex justify-space-around">
        <v-col cols="12" sm="12" md="3" class="ma-auto">
          <h1>Maquinado</h1>
        </v-col>
        <!-- <v-col cols="12" sm="12" md="3" class="ma-auto mb-n6"> -->
          <!-- <v-text-field dense outlined label="Buscar Maquinado" v-model="buscador" class="mx-2"/> -->
        <!-- </v-col> -->
        <v-col cols="12" sm="12" md="3" class="ma-auto">
          <v-btn class="mt-2 success darken-1" small text to="/nuevoMaquinado">Asignar Maquinado</v-btn>
        </v-col>
      </v-row>
    </v-container>

      <v-card class="ma-3">
        <v-row class="mx-3 my-3">
          <v-btn class="success darken-1 ma-auto mt-2" small text @click="getItems()">Actualizar</v-btn>
          <v-spacer></v-spacer>
          <v-text-field
            class="ma-3"
            v-model="buscador"
            label="Buscar"
            append-icon="mdi-magnify"
            single-line
            hide-details=""
          />
        </v-row>

        <v-data-table :items="filtrarMaquinado" :headers="columnas" :loading="cargando"  item-key="MAQUINADO_ID" class="tamTexto">
          
          <template v-slot:[`item.FECHA_ENTRADA`]="{ item }">
            {{validarDatos(item.FECHA_ENTRADA)}}
          </template>
          
          <template v-slot:[`item.ALMACEN_DESTINO`]="{ item }">
            {{validarDatos(item.ALMACEN_DESTINO)}}
          </template>
          
          <template v-slot:[`item.ESTATUS`]="{ item }">
            {{estatus(item)}}
          </template>
          
          <template v-slot:[`item.accionOpciones`]="{ item }">
            <v-icon @click="$router.push(`/editarMaquinado/${item.MAQUINADO_ID}`)" color="amber accent-4">mdi-pencil</v-icon>
          </template>

          <template v-slot:[`item.accionEliminar`]="{ item }">
            <v-icon :disabled="item.ESTATUS == 'T' || item.ESTATUS =='B'" @click="cambiarEstatus(item)" color="red ">mdi-cog-transfer</v-icon>
          </template>

          <template slot="no-data">
            <v-alert class="my-2" :value="true" type="info" color="orange darken-1" >
              <span class="font-weight-medium"> No se encontro informacion para mostrar.</span>
            </v-alert>
          </template>

        </v-data-table>
      </v-card>
    </div>
</template>

<script>
import axios from 'axios'
import { mapGetters } from 'vuex'
export default {
  // ------------------------------------------------------------------------------
  data() {
    return {

      // Tabla items
      items:[],
      buscador:'',
      columnas:[
        {text: "Folio",          value:"FOLIO",                  class:'primary lighten-1 white--text'},
        {text: "Fecha Salida",    value:"FECHA_SALIDA",           class:'primary lighten-1 white--text'},
        {text: "Proyecto",    value:"PFOLIO",           class:'primary lighten-1 white--text'},
        {text: "Almacen Salida",  value:"ALMACEN",                class:'primary lighten-1 white--text'},
        {text: "Fecha Entrada",   value:"FECHA_ENTRADA",           class:'primary lighten-1 white--text'},
        {text: "Almacen Destino", value:"ALMACEN_DESTINO",        class:'primary lighten-1 white--text'},
        {text: "Estatus", value:"ESTATUS",                        class:'primary lighten-1 white--text'},
        {text: "Opciones",value:"accionOpciones",sortable:false,  class:'primary lighten-1 white--text'},
        {text: "Accion",  value:"accionEliminar",  sortable:false,class:'primary lighten-1 white--text'},
      ],
      cargando:false,
    }
  },

  // ------------------------------------------------------------------------------
  computed: {
    ...mapGetters(['getURLAPI','getRolesUsuario','getUsuario']),

    filtrarMaquinado(){
      return this.items.filter( (maquinado) => {
        return   maquinado.FOLIO   .toLowerCase().match( this.buscador.toLowerCase() )

              || maquinado.FECHA_SALIDA.match(this.buscador)
              || this.validarDatos(maquinado.PFOLIO)  .toLowerCase().match( this.buscador.toLowerCase() )

              || maquinado.ALMACEN  .toLowerCase().match( this.buscador.toLowerCase() )
              || this.validarDatos(maquinado.FECHA_ENTRADA).match(this.buscador)

              || this.validarDatos(maquinado.ALMACEN_DESTINO).toLowerCase().match( this.buscador.toLowerCase() )
              || this.estatus(maquinado).toLowerCase().match( this.buscador.toLowerCase() )
      })
    }

  },

  // ------------------------------------------------------------------------------
  methods: {
    // ------------------------------------------------------------------------------
    // almacenDestino( item ){
    //   let destino
    // },

    // ------------------------------------------------------------------------------
    estatus(item){
      let msg;
      switch (item.ESTATUS) {
        case 'A':
          msg = "ACTIVO"
          break;

        case 'B':
          msg = "BAJA"
          break;

        case 'T':
          msg = "TERMINADO"
          break;

        default:
          "Default"
          break;
      }
      return msg;
    },

    // ------------------------------------------------------------------------------
    validarDatos( msg ){
      if(msg)
        return msg;
      else
        return 'N/A'
      
    },

    // ------------------------------------------------------------------------------
    async getItems(){
      this.cargando = true;
      this.items =[];

      if (this.getRolesUsuario.includes('SA') || this.getRolesUsuario.includes('ADMIN')) {
        
        // console.log("if");
        this.items = (await axios.get(`${this.getURLAPI}/Show/allMaquinado`)).data
      } else {
        // console.log("else");
        let datosForm = new FormData();
        datosForm.append("USUARIO_CREADOR",this.getUsuario);
        this.items = (await axios.post(`${this.getURLAPI}/Show/allMaquinadoUsuario`,datosForm)).data
      }

      this.cargando = false;
    },

    // ------------------------------------------------------------------------------
    cambiarEstatus( item ){
      let confirm = window.confirm(`¿Seguro que deseas eliminar el Maquinado con folio: ${item.FOLIO}?`);

      if(confirm){
        let datosForm = new FormData();
        datosForm.append("MAQUINADO_ID" , item.MAQUINADO_ID);
  
        axios.post(`${this.getURLAPI}/Maquinado/cambiarEstatus`,datosForm)
        .then( ({data}) => {
          this.$root.vtoast.show(
            { 
              message: data.MSG, 
              color:data.STATUS=="OK" ? 'success darken-1' : "red darken-1", 
              timer:10000,
              icon: data.STATUS=="OK" ? 'mdi-check':'mdi-alert-circle-outline' 
            } 
          )
          this.getItems();
        })

      }

    },

  },

  

  // ------------------------------------------------------------------------------
  created() {
    document.title = "Maquinado | Bombas y Suministros del Norte"
    this.getItems();
  },
}
</script>

<style>

</style>